(function() {
  ACC.imgLazyLoad = {

    loadImageSmartly: function(container, observer) {
      if (container.getAttribute('data-src')) {
        container.setAttribute('src', container.getAttribute('data-src'));
        observer.unobserve(container);
      }
    },
    setImageObserver: function() {
      function intersection(container) {
        var observer = new IntersectionObserver(function(entries) {
          entries.map(function(entry) {
            var isIntersecting = entry.isIntersecting;

            if (isIntersecting) {
              ACC.imgLazyLoad.loadImageSmartly(container, observer);
            }

            return true;
          }, {
            root: null,
            rootMargin: '0px',
            threshold: 0
          });
        });

        observer.observe(container);
      }

      var lazyloadedImgNodes = document.querySelectorAll('.ph-imagelazyload');

      if ('IntersectionObserver' in window) {
        lazyloadedImgNodes.forEach(function(entry) {
          intersection(entry);
        });
      } else {
        $.getScript(ACC.config.commonResourcePath + '/philipsUI/src/js/vendor/intersection-observer.min.js', function() {
          for (var i = 0; i < lazyloadedImgNodes.length; i = i + 1) {
            intersection(lazyloadedImgNodes[i]);
          }
        });
      }
    }
  };

  $(document).ready(function() {
    ACC.imgLazyLoad.setImageObserver();
  });
})();

